import React, { useEffect } from "react";
import Stats from "./Stats";
import { Grid } from "@material-ui/core";

import { red } from "@material-ui/core/colors";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { getPeriodicSales } from "../../redux/actions/salesActions";

// helpers
import { formatCurrency } from "../../utils/helpers";

const SalesThisYear = ({ period }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    getPeriodicSales(dispatch, period);
  }, [dispatch, period]);

  const {
    salesThisYearSummary: { loading, sales },
  } = useSelector((state) => state.sales);

  return (
    <Grid item xs={12} sm={12} md={6} lg={3} xl>
      <Stats
        title="Sales This Year"
        loading={loading}
        data={`${formatCurrency("KES", sales)}`}
        amount="KES 24,000,300"
        chip="Annual"
        percentageText="-14%"
        percentagecolor={red[500]}
      />
    </Grid>
  );
};

export default SalesThisYear;
